import { useMemo } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';
import { useMediaLoader } from './hooks/useMediaLoader';

import Advt from './components/Advt/Advt';
import { Question } from './components/Question/Question';
import { MessagesList } from './components/MessagesList/MessagesList';
import { ResultQuiz } from './components/ResultQuiz/ResultQuiz';

import bgDefaultVideo from './assets/video/bgVideo.webm';
import posterDefault from './assets/images/bgPoster.webp';

function App() {
  const { voteState, currentState } = useVote();
  const { showedMessages, winnerMessage, speed } = useCarousel();

  const { bgVideo, bgPoster, authorFontSize } = useGetParams();

  const srcVideo = useMemo(() => {
    let correctVar = voteState?.vars?.find((el) => el.correct);
    if (correctVar) {
      let keyWords = JSON.parse(correctVar?.name || {}) || [];
      let numberPlayer = keyWords.find((word) => {
        const num = Number(word);
        if (!isNaN(num) && word !== '') {
          return num;
        } else return false;
      });

      const protocol = window?.location.protocol || 'https:';
      return numberPlayer
        ? `${protocol}//stream-test.iactive.pro/dinamo-altai-hk/videos/${numberPlayer}.webm`
        : numberPlayer;
    } else return false;
  }, [voteState?.vars]);

  // контроль загрузки медиа
  const { isFullyLoaded } = useMediaLoader(srcVideo, 'video');

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            style={{ width: '100%', height: '100%' }}
            key="question"
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.5 }}
          >
            <Question title={voteState?.title} key="question" />
          </motion.div>
        )}
        {currentState === 'S2' && (
          <motion.div
            key="advt"
            style={{ width: '100%', height: '100%' }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Advt />
          </motion.div>
        )}

        {currentState === 'S3' && isFullyLoaded && (
          <motion.div
            key={srcVideo}
            style={{ width: '100%', height: '100%', position: 'relative' }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <ResultQuiz playerSrc={srcVideo} />
          </motion.div>
        )}

        {['S4', 'S5', 'S6'].includes(currentState) && (
          <MessagesList
            key="msgList"
            winId={winnerMessage?.message.id}
            messages={showedMessages}
            authorFontSize={authorFontSize}
            currentState={currentState}
            speed={speed || 0}
          />
        )}
      </AnimatePresence>

      {bgVideo && (
        <video
          autoPlay="autoplay"
          muted="muted"
          loop
          playsInline
          poster={bgVideo === '1' ? posterDefault : bgPoster}
          id="bgVideo"
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          ></source>
        </video>
      )}
    </div>
  );
}

export default App;
